import { action } from 'typesafe-actions';
import { asyncAction } from 'store/utils/promiseAction';

import {
  CarList,
  ChartReportInterface,
  EmtuReportInterface,
  EmvApprovedByAttemptsInterface,
  EmvApprovedByBrandInterface,
  EmvApprovedByDebtRecoveryInterface,
  EmvApprovedByFirstTapByBrandInterface,
  EmvDeclinedByReasonInterface,
  EmvEntryGetHistoryInterface,
  EmvEntryGetInterface,
  EntryGroupedInterface,
  EntrySimplifiedInterface,
  ExternalReportsInterface,
  FilterItems,
  GeneralReportInterface,
  HeatmapInterface,
  IncomingByKmValueReportInterface,
  InterfaceBpeReportList,
  InterfaceBpeTaxVerificationReportList,
  InterfaceGratuitiesReportList,
  InvoiceInterface,
  KmPerDayReportInterface,
  LineDemandReportInterface,
  PassengersAndVehiclesByTripReportInterface,
  TimedOutEntriesInterface,
  PassengersAndVehiclesReportInterface,
  PassengersByOrigin,
  PaymentInterface,
  PaymentRequestInterface,
  ReportDurableClientResponseInterface,
  ReportDurableDownloadPayloadInterface,
  ReportDurableCancelPayloadInterface,
  ReportDurableCancelResponseInterface,
  ReportDurableListPayloadInterface,
  ReportDurableListResponseInterface,
  ReportDurableStatusPayloadInterface,
  ReportDurableStatusResponseInterface,
  PedestriansEntryByTerminalInterface,
  ProfileByAgeGroupListInterface,
  ReportsTypes,
  scheduleDeleteInterface,
  ScheduleInterface,
  SectionData,
  SelectedCarInterface,
  SelectedCompaniesInterface,
  SelectedCreditType,
  SelectedDbdInterface,
  SelectedEmployeesInterface,
  SelectedDriverRegistryInterface,
  SelectedLinesInterface,
  SelectedPaymentsInterface,
  SelectedPaymentStatusInterface,
  SelectedOperationTypeInterface,
  SelectedProfilesInterface,
  SelectedQRcodesInterface,
  SelectedReceivePaymentsInterface,
  SelectedReportTypesInterface,
  SelectedSupervisorInterface,
  SelectedTerminalInterface,
  SelectedTokenStatus,
  ShipmentByLineInterface,
  SuperiorAccessReportInterface,
  TransportedPassengersByTimeFrame,
  TransportedPassengersByTimeFrameByProfile,
  TransportedPassengersInterface,
  TravelByLineInterface,
  UsageStatisticsInterface,
} from './types';

// Get Chart Report
export const getChartReportRequest = (payload: object) =>
  action(ReportsTypes.GET_CHART_REPORT_REQUEST, payload);

export const getChartReportSuccess = (payload: {
  chartReportList: ChartReportInterface;
}) => action(ReportsTypes.GET_CHART_REPORT_SUCCESS, payload);

export const getChartReportFailure = () =>
  action(ReportsTypes.GET_CHART_REPORT_FAILURE);

// Get Invoices List
export const getInvoicesListRequest = (payload: { body: object }) =>
  action(ReportsTypes.GET_INVOICES_LIST_REQUEST, payload);
export const listInvoicesListRequest = (payload: {
  body: object;
  isCsvFull?: boolean;
}) => action(ReportsTypes.LIST_INVOICES_LIST_REQUEST, payload);

export const getInvoicesListSuccess = (payload: {
  isCsvFull?: boolean;
  invoicesList: InvoiceInterface[];
  totalCount: number;
}) => action(ReportsTypes.GET_INVOICES_LIST_SUCCESS, payload);

export const getInvoicesListFailure = () =>
  action(ReportsTypes.GET_INVOICES_LIST_FAILURE);

// Get Transported Passengers
export const getTransportedPassengersRequest = (payload: object) =>
  action(ReportsTypes.GET_TRANSPORTED_PASSENGERS_REPORT_REQUEST, payload);

export const getTransportedPassengersSuccess = (payload: {
  transportedPassengersList: TransportedPassengersInterface[];
}) => action(ReportsTypes.GET_TRANSPORTED_PASSENGERS_REPORT_SUCCESS, payload);

export const getTransportedPassengersFailure = () =>
  action(ReportsTypes.GET_TRANSPORTED_PASSENGERS_REPORT_FAILURE);

// Get KM Drived
export const getKmDrivedReportRequest = (payload: object) =>
  action(ReportsTypes.GET_KM_DRIVED_REPORT_REQUEST, payload);

export const getKmDrivedReportSuccess = (payload: {
  kmDrivedList: TransportedPassengersInterface[];
}) => action(ReportsTypes.GET_KM_DRIVED_REPORT_SUCCESS, payload);

export const getKmDrivedReportFailure = () =>
  action(ReportsTypes.GET_KM_DRIVED_REPORT_FAILURE);

// Get Gate Entry
export const getGateEntryReportRequest = (payload: object) =>
  action(ReportsTypes.GET_GATE_ENTRY_REPORT_REQUEST, payload);

export const getGateEntryReportSuccess = (payload: {
  gateEntryReportList: any;
}) => action(ReportsTypes.GET_GATE_ENTRY_REPORT_SUCCESS, payload);

export const getGateEntryReportFailure = () =>
  action(ReportsTypes.GET_GATE_ENTRY_REPORT_FAILURE);

// List Car
export const carListReportRequest = (payload: object) =>
  action(ReportsTypes.LIST_CAR_REPORT_REQUEST, payload);

export const carListReportSuccess = (payload: { carList: CarList[] }) =>
  action(ReportsTypes.LIST_CAR_REPORT_SUCCESS, payload);

export const carListReportFailure = () =>
  action(ReportsTypes.LIST_CAR_REPORT_FAILURE);

// Get Passengers by Origin
export const getPassengersByOriginReportRequest = (payload: object) =>
  action(ReportsTypes.GET_PASSENGERS_BY_ORIGIN_REPORT_REQUEST, payload);

export const getPassengersByOriginReportSuccess = (payload: {
  passengersByOriginReportList: PassengersByOrigin[];
}) => action(ReportsTypes.GET_PASSENGERS_BY_ORIGIN_REPORT_SUCCESS, payload);

export const getPassengersByOriginReportFailure = () =>
  action(ReportsTypes.GET_PASSENGERS_BY_ORIGIN_REPORT_FAILURE);

// Get Chart Line Report
export const lineDemandReportRequest = (payload: object) =>
  action(ReportsTypes.LINE_DEMAND_REPORT_REQUEST, payload);

export const lineDemandReportSuccess = (payload: {
  lineDemandReportList: LineDemandReportInterface;
}) => action(ReportsTypes.LINE_DEMAND_REPORT_SUCCESS, payload);

export const lineDemandReportFailure = () =>
  action(ReportsTypes.LINE_DEMAND_REPORT_FAILURE);

// Get Chart Line Quantity Report
export const lineQuantityReportRequest = (payload: object) =>
  action(ReportsTypes.LINE_QUANTITY_REPORT_REQUEST, payload);

export const lineQuantityReportSuccess = (payload: {
  lineQuantityReportList: LineDemandReportInterface;
}) => action(ReportsTypes.LINE_QUANTITY_REPORT_SUCCESS, payload);

export const lineQuantityReportFailure = () =>
  action(ReportsTypes.LINE_QUANTITY_REPORT_FAILURE);

// Get KM Per Day Report
export const kmPerDayReportRequest = (payload: object) =>
  action(ReportsTypes.KM_BY_DAY_REPORT_REQUEST, payload);

export const kmPerDayReportSuccess = (payload: {
  kmByDayReportList: KmPerDayReportInterface[];
}) => action(ReportsTypes.KM_BY_DAY_REPORT_SUCCESS, payload);

export const kmPerDayReportFailure = () =>
  action(ReportsTypes.KM_BY_DAY_REPORT_FAILURE);

// GET_PASSENGERS_AND_VEHICLES_REPORT
export const getPassengersAndVehiclesRequest = (payload: object) =>
  action(ReportsTypes.GET_PASSENGERS_AND_VEHICLES_REPORT_REQUEST, payload);

export const getPassengersAndVehiclesSuccess = (payload: {
  passengersAndVehiclesReportList: PassengersAndVehiclesReportInterface[];
}) => action(ReportsTypes.GET_PASSENGERS_AND_VEHICLES_REPORT_SUCCESS, payload);

export const getPassengersAndVehiclesFailure = () =>
  action(ReportsTypes.GET_PASSENGERS_AND_VEHICLES_REPORT_FAILURE);

// GET_PASSENGERS_AND_VEHICLES_BY_TRIP_REPORT
export const getPassengersAndVehiclesByTripRequest = (payload: object) =>
  action(
    ReportsTypes.GET_PASSENGERS_AND_VEHICLES_BY_TRIP_REPORT_REQUEST,
    payload,
  );

export const getPassengersAndVehiclesByTripSuccess = (payload: {
  passengersAndVehiclesByTripReportList: PassengersAndVehiclesByTripReportInterface[];
}) =>
  action(
    ReportsTypes.GET_PASSENGERS_AND_VEHICLES_BY_TRIP_REPORT_SUCCESS,
    payload,
  );

export const getPassengersAndVehiclesByTripFailure = () =>
  action(ReportsTypes.GET_PASSENGERS_AND_VEHICLES_BY_TRIP_REPORT_FAILURE);

// GET_TIMED_OUT_ENTRIES
export const getTimedOutEntriesRequest = (payload: object) =>
  action(ReportsTypes.GET_TIMED_OUT_ENTRIES_REPORT_REQUEST, payload);

export const getTimedOutEntriesSuccess = (payload: {
  timedOutEntriesList: TimedOutEntriesInterface[];
}) => action(ReportsTypes.GET_TIMED_OUT_ENTRIES_REPORT_SUCCESS, payload);

export const getTimedOutEntriesFailure = () =>
  action(ReportsTypes.GET_TIMED_OUT_ENTRIES_REPORT_FAILURE);

// GET_PASSENGERS_AND_VEHICLES_BY_TRIP_REPORT
export const getPedestrianEntryByTerminalRequest = (payload: object) =>
  action(ReportsTypes.GET_PEDESTRIAN_ENTRY_BY_TERMINAL_REPORT_REQUEST, payload);

export const getPedestrianEntryByTerminalSuccess = (payload: {
  pedestriansEntryByTerminalList: PedestriansEntryByTerminalInterface[];
}) =>
  action(ReportsTypes.GET_PEDESTRIAN_ENTRY_BY_TERMINAL_REPORT_SUCCESS, payload);

export const getPedestrianEntryByTerminalFailure = () =>
  action(ReportsTypes.GET_PEDESTRIAN_ENTRY_BY_TERMINAL_REPORT_FAILURE);

// Set Seccione Lines
export const setSeccionedLines = (payload: {
  selectedSeccionedLine: number | null;
}) => action(ReportsTypes.SET_SECCIONED_LINES, payload);

// Get Chart Daily Report
export const dailyDemandReportRequest = (payload: object) =>
  action(ReportsTypes.DAILY_DEMAND_REPORT_REQUEST, payload);

export const dailyDemandReportSuccess = (payload: {
  dailyDemandReportList: LineDemandReportInterface;
}) => action(ReportsTypes.DAILY_DEMAND_REPORT_SUCCESS, payload);

export const dailyDemandReportFailure = () =>
  action(ReportsTypes.DAILY_DEMAND_REPORT_FAILURE);

// Get transportedPassengersByTimeFrame
export const transportedPassengersByTimeFrameReportRequest = (
  payload: object,
) =>
  action(
    ReportsTypes.TRANSPORTED_PASSENGERS_BY_TIMEFRAME_REPORT_REQUEST,
    payload,
  );

export const transportedPassengersByTimeFrameReportSuccess = (payload: {
  transportedPassengersByTimeFrameList: TransportedPassengersByTimeFrame[];
}) =>
  action(
    ReportsTypes.TRANSPORTED_PASSENGERS_BY_TIMEFRAME_REPORT_SUCCESS,
    payload,
  );

export const transportedPassengersByTimeFrameReportailure = () =>
  action(ReportsTypes.TRANSPORTED_PASSENGERS_BY_TIMEFRAME_REPORT_FAILURE);

// Get transportedPassengersByTimeFrame
export const transportedPassengersByTimeFrameByProfileReportRequest = (
  payload: object,
) =>
  action(
    ReportsTypes.TRANSPORTED_PASSENGERS_BY_TIMEFRAME_BY_PROFILE_REPORT_REQUEST,
    payload,
  );

export const transportedPassengersByTimeFrameByProfileReportSuccess = (payload: {
  transportedPassengersByTimeFrameByProfileList: TransportedPassengersByTimeFrameByProfile[];
}) =>
  action(
    ReportsTypes.TRANSPORTED_PASSENGERS_BY_TIMEFRAME_BY_PROFILE_REPORT_SUCCESS,
    payload,
  );

export const transportedPassengersByTimeFrameByProfileReportailure = () =>
  action(
    ReportsTypes.TRANSPORTED_PASSENGERS_BY_TIMEFRAME_BY_PROFILE_REPORT_FAILURE,
  );

// Get Chart Daily Quantity Report
export const dailyQuantityReportRequest = (payload: object) =>
  action(ReportsTypes.DAILY_QUANTITY_REPORT_REQUEST, payload);

export const dailyQuantityReportSuccess = (payload: {
  dailyQuantityReportList: LineDemandReportInterface;
}) => action(ReportsTypes.DAILY_QUANTITY_REPORT_SUCCESS, payload);

export const dailyQuantityReportFailure = () =>
  action(ReportsTypes.DAILY_QUANTITY_REPORT_FAILURE);

// Get Chart Daily Quantity Report
export const dailyQuantitySeccionedReportRequest = (payload: object) =>
  action(ReportsTypes.DAILY_QUANTITY_SECCIONED_REPORT_REQUEST, payload);

export const dailyQuantitySeccionedReportSuccess = (payload: {
  dailyQuantitySeccionedReportList: LineDemandReportInterface;
}) => action(ReportsTypes.DAILY_QUANTITY_SECCIONED_REPORT_SUCCESS, payload);

export const dailyQuantitySeccionedReportFailure = () =>
  action(ReportsTypes.DAILY_QUANTITY_SECCIONED_REPORT_FAILURE);

// Get Chart Entry Report
export const getChartEntryReportRequest = (payload: object) =>
  action(ReportsTypes.GET_CHART_ENTRY_REPORT_REQUEST, payload);

export const getChartEntryReportSuccess = (payload: {
  chartEntryReportList: LineDemandReportInterface;
}) => action(ReportsTypes.GET_CHART_ENTRY_REPORT_SUCCESS, payload);

export const getChartEntryReportFailure = () =>
  action(ReportsTypes.GET_CHART_ENTRY_REPORT_FAILURE);

// Get Chart Entry Report Simplified
export const getChartEntryReportSimplifiedRequest = (payload: any) =>
  asyncAction(ReportsTypes.GET_CHART_ENTRY_REPORT_SIMPLIFIED_REQUEST, payload);

export const getChartEntryReportSimplifiedSuccess = (payload: {
  chartEntryReportSimplifiedList: EntrySimplifiedInterface[];
}) => action(ReportsTypes.GET_CHART_ENTRY_REPORT_SIMPLIFIED_SUCCESS, payload);

export const getChartEntryReportSimplifiedFailure = () =>
  action(ReportsTypes.GET_CHART_ENTRY_REPORT_SIMPLIFIED_FAILURE);

// Entry Report Grouped
export const entryReportGroupedRequest = (payload: object) =>
  action(ReportsTypes.ENTRY_REPORT_GROUPED_REQUEST, payload);

export const entryReportGroupedSuccess = (payload: {
  entryReportListGrouped: EntryGroupedInterface;
}) => action(ReportsTypes.ENTRY_REPORT_GROUPED_SUCCESS, payload);

export const entryReportGroupedFailure = () =>
  action(ReportsTypes.ENTRY_REPORT_GROUPED_FAILURE);

// Get Chart Entry Report Simplified
export const getSuperiorAccessReportRequest = (payload: any) =>
  action(ReportsTypes.GET_SUPERIOR_ACCESS_REPORT_REQUEST, payload);

export const getSuperiorAccessReportSuccess = (payload: {
  superiorAccessReportList: SuperiorAccessReportInterface;
}) => action(ReportsTypes.GET_SUPERIOR_ACCESS_REPORT_SUCCESS, payload);

export const getSuperiorAccessReportFailure = () =>
  action(ReportsTypes.GET_SUPERIOR_ACCESS_REPORT_FAILURE);

// Chips Entry
export const chipsListEntry = (payload: { chipsListEntry: any }) =>
  action(ReportsTypes.CREATE_CHIPS_LIST_ENTRY, payload);

export const cleanChipsListEntry = () =>
  action(ReportsTypes.CLEAN_CHIPS_LIST_ENTRY);

// Chips Value
export const chipsListValue = (payload: { chipsListValue: any }) =>
  action(ReportsTypes.CREATE_CHIPS_LIST_VALUE, payload);

export const cleanChipsListValue = () =>
  action(ReportsTypes.CLEAN_CHIPS_LIST_VALUE);

// Chips Line
export const chipsListLine = (payload: { chipsListLine: any }) =>
  action(ReportsTypes.CREATE_CHIPS_LIST_LINE, payload);

export const cleanChipsListLine = () =>
  action(ReportsTypes.CLEAN_CHIPS_LIST_LINE);

// Chips Heatmap
export const chipsHeatmap = (payload: { chipsHeatmap: any }) =>
  action(ReportsTypes.CREATE_CHIPS_HEATMAP, payload);

export const cleanChipsHeatmap = () => action(ReportsTypes.CLEAN_CHIPS_HEATMAP);

// Chips Payment Report
export const cleanChipsPaymentReport = () =>
  action(ReportsTypes.CLEAN_CHIPS_PAYMENT_REPORT);

export const chipsPaymentReport = (payload: { chipsPaymentReport: any }) =>
  action(ReportsTypes.CREATE_CHIPS_PAYMENT_REPORT, payload);

// Chips Fleet
export const chipsFleet = (payload: { chipsFleet: any }) =>
  action(ReportsTypes.CREATE_CHIPS_FLEET, payload);

// Chips Travel
export const chipsTravel = (payload: { chipsTravel: any }) =>
  action(ReportsTypes.CREATE_CHIPS_TRAVEL, payload);

export const cleanChipsTravel = () => action(ReportsTypes.CLEAN_CHIPS_TRAVEL);

// Heatmap Report
export const getHeatmapReportRequest = (payload: object) =>
  action(ReportsTypes.GET_HEATMAP_REPORT_REQUEST, payload);

export const getHeatmapReportSuccess = (payload: {
  heatmapList: HeatmapInterface;
}) => action(ReportsTypes.GET_HEATMAP_REPORT_SUCCESS, payload);

export const getHeatmapReportFailure = () =>
  action(ReportsTypes.GET_HEATMAP_REPORT_FAILURE);

// General Report
export const generalReportRequest = (payload: object) =>
  action(ReportsTypes.GENERAL_REPORT_REQUEST, payload);

export const generalReportSuccess = (payload: {
  generalReportList: GeneralReportInterface[];
}) => action(ReportsTypes.GENERAL_REPORT_SUCCESS, payload);

export const generalReportFailure = () =>
  action(ReportsTypes.GENERAL_REPORT_FAILURE);

// Set Selected Invoice Status
export const setSelectedInvoiceStatus = (payload: {
  selectedInvoiceStatus: number | null;
}) => action(ReportsTypes.SET_SELECTED_INVOICE_STATUS, payload);

// Set Selected Cars
export const setSelectedCarsId = (payload: { selectedCarsId: string[] }) =>
  action(ReportsTypes.SET_SELECTED_CARS_ID, payload);

export const setSelectedCars = (payload: {
  selectedCars: SelectedCarInterface[];
}) => action(ReportsTypes.SET_SELECTED_CARS, payload);

export const setSelectedTerminals = (payload: {
  selectedTerminals: SelectedTerminalInterface[];
}) => action(ReportsTypes.SET_SELECTED_TERMINALS, payload);

// Set Selected Profiles
export const setSelectedProfiles = (payload: {
  selectedProfiles: SelectedProfilesInterface[];
}) => action(ReportsTypes.SET_SELECTED_PROFILES, payload);

// Set Selected Payments
export const setSelectedPayments = (payload: {
  selectedPayments: SelectedPaymentsInterface[];
}) => action(ReportsTypes.SET_SELECTED_PAYMENTS, payload);

// Set Selected Payments Stattus
export const setSelectedPaymentStatus = (payload: {
  selectedPaymentStatus: SelectedPaymentStatusInterface[];
}) => action(ReportsTypes.SET_SELECTED_PAYMENT_STATUS, payload);

// Set Selected Payments Stattus
export const setSelectedOperationType = (payload: {
  selectedOperationType: SelectedOperationTypeInterface[];
}) => action(ReportsTypes.SET_SELECTED_OPERATION_TYPE, payload);

// Set Selected QRCodes
export const setSelectedQRCodes = (payload: {
  selectedQRCodes: SelectedQRcodesInterface[];
}) => action(ReportsTypes.SET_SELECTED_QRCODES, payload);

// Set Selected Lines
export const setSelectedLines = (payload: {
  selectedLines: SelectedLinesInterface[];
}) => action(ReportsTypes.SET_SELECTED_LINES, payload);

// Set Selected Benefits
export const setSelectedBenefit = (payload: {
  selectedBenefits: SelectedLinesInterface[];
}) => action(ReportsTypes.SET_SELECTED_BENEFIT, payload);

// Set Selected Schools
export const setSelectedSchools = (payload: { selectedSchools: any }) =>
  action(ReportsTypes.SET_SELECTED_SCHOOLS, payload);

// Set Selected EmvType
export const setSelectedEmvType = (payload: {
  selectedEmvType: SelectedReportTypesInterface[];
}) => action(ReportsTypes.SET_SELECTED_EMVTYPE, payload);

// Set Selected Lines
export const setSelectedBrand = (payload: {
  selectedBrand: SelectedReportTypesInterface[];
}) => action(ReportsTypes.SET_SELECTED_BRAND, payload);

// Set Selected Section Lines used in PathAutocomete
export const setSelectedSectionLines = (payload: {
  selectedSectionLines: { start: SectionData[]; end: SectionData[] };
}) => action(ReportsTypes.SET_SELECTED_SECTION_LINES, payload);

// Set Selected Filename
export const setSelectedFilename = (payload: { filenameSelected: string }) =>
  action(ReportsTypes.SET_SELECTED_FILENAME, payload);

// Set Selected Employees
export const setSelectedEmployees = (payload: {
  selectedEmployees: SelectedEmployeesInterface[];
}) => action(ReportsTypes.SET_SELECTED_EMPLOYEES, payload);

// Set Selected Driver Registry
export const setSelectedDriverRegistry = (payload: {
  selectedDriverRegistry: SelectedDriverRegistryInterface[];
}) => action(ReportsTypes.SET_SELECTED_DRIVER_REGISTRY, payload);

// Set Selected Start Date
export const setSelectedStartDate = (payload: {
  selectedStartDate: Date | null;
}) => action(ReportsTypes.SET_SELECTED_START_DATE, payload);

// Set Selected End Date
export const setSelectedEndDate = (payload: { selectedEndDate: Date | null }) =>
  action(ReportsTypes.SET_SELECTED_END_DATE, payload);

// Set Selected startedAt
export const setSelectedStartedAt = (payload: { startedAt: Date | null }) =>
  action(ReportsTypes.SET_SELECTED_STARTED_AT_DATE, payload);

// Set Selected Profile Expiration
export const setSelectedProfileExpiration = (payload: {
  selectedProfileExpiration: Date | null;
}) => action(ReportsTypes.SET_SELECTED_PROFILE_EXPIRATION, payload);

// Set Selected CNPJ
export const setSelectedCNPJ = (payload: { selectedCNPJ: string }) =>
  action(ReportsTypes.SET_SELECTED_CNPJ, payload);

// Set Selected NSU
export const setSelectedNSU = (payload: { selectedNSU: string }) =>
  action(ReportsTypes.SET_SELECTED_NSU, payload);

// Set Selected Phone
export const setSelectedPhone = (payload: { selectedPhone: string }) =>
  action(ReportsTypes.SET_SELECTED_PHONE, payload);

// Set History Filter
export const setHistoryFilter = (payload: { history: boolean | null }) =>
  action(ReportsTypes.SET_HISTORY_FILTER, payload);

// Set Selected Number of days
export const setSelectedNumberOfDays = (payload: { numberOfDays: number }) =>
  action(ReportsTypes.SET_SELECTED_NUMBER_OF_DAYS, payload);

// Set Selected Receive Payments
export const setSelectedReceivePayments = (payload: {
  selectedReceivePayments: SelectedReceivePaymentsInterface[];
}) => action(ReportsTypes.SET_SELECTED_RECEIVE_PAYMENTS, payload);

// Set Selected Trip Status
export const setSelectedTripStatus = (payload: {
  selectedTripStatus: SelectedQRcodesInterface[];
}) => action(ReportsTypes.SET_SELECTED_TRIP_STATUS, payload);

// Set Selected Trip Status
export const setSelectedTripOrTicket = (payload: {
  selectedTripOrTicket: string;
}) => action(ReportsTypes.SET_SELECTED_TRIP_OR_TICKET, payload);

// Set Selected Supervisor
export const setSelectedSupervisors = (payload: {
  selectedSupervisors: SelectedSupervisorInterface[];
}) => action(ReportsTypes.SET_SELECTED_SUPERVISOR, payload);

// Set Selected Dbds
export const setSelectedDbds = (payload: {
  selectedDbds: SelectedDbdInterface[];
}) => action(ReportsTypes.SET_SELECTED_DBD, payload);

// Set Selected Token Status
export const setSelectedTokenStatus = (payload: {
  selectedTokenStatus: SelectedTokenStatus | null;
}) => action(ReportsTypes.SET_SELECTED_TOKEN_STATUS, payload);

// Set Selected TYPE Status
export const setSelectedCreditType = (payload: {
  selectedCreditType: Array<SelectedCreditType>;
}) => action(ReportsTypes.SET_SELECTED_CREDIT_TYPE, payload);

// Set Selected Name
export const setSelectedName = (payload: { selectedName: string }) =>
  action(ReportsTypes.SET_SELECTED_NAME, payload);

// Set Selected Bpe Code
export const setSelectedBpeCode = (payload: { selectedBpeCode: string }) =>
  action(ReportsTypes.SET_SELECTED_BPE_CODE, payload);

// Set Selected Bpe Number
export const setSelectedBpeNumber = (payload: { selectedBpeNumber: string }) =>
  action(ReportsTypes.SET_SELECTED_BPE_NUMBER, payload);

// Set Selected Ticket Id Code
export const setSelectedTicketIdCode = (payload: { selectedTicketIdCode: string }) =>
  action(ReportsTypes.SET_SELECTED_TICKET_ID_CODE, payload);

// Set Selected Sale Id Code
export const setSelectedSaleIdCode = (payload: { selectedSaleIdCode: string }) =>
  action(ReportsTypes.SET_SELECTED_SALE_ID_CODE, payload);

// Set Selected Bpe Number
export const setSelectedIncludeBpe = (payload: {
  selectedIncludeBpe: string;
}) => action(ReportsTypes.SET_SELECTED_INCLUDE_BPE, payload);

// Set Selected Origin
export const setSelectedOrigin = (payload: { selectedOrigin: string }) =>
  action(ReportsTypes.SET_SELECTED_ORIGIN, payload);

// Set Selected Destiny
export const setSelectedDestiny = (payload: { selectedDestiny: string }) =>
  action(ReportsTypes.SET_SELECTED_DESTINY, payload);

// Set Selected Line Section Name
export const setSelectedLineSectionName = (payload: {
  selectedLineSectionName: string;
}) => action(ReportsTypes.SET_SELECTED_LINE_SECTION_NAME, payload);

// Set Selected Document Type
export const setSelectedDocumentType = (payload: {
  selectedDocumentType: number | null;
}) => action(ReportsTypes.SET_SELECTED_DOCUMENT_TYPE, payload);

// Payment Report
export const paymentReportRequest = (payload: any) =>
  action(ReportsTypes.PAYMENT_REPORT_REQUEST, payload);

export const paymentReportSuccess = (payload: {
  paymentList: PaymentInterface;
}) => action(ReportsTypes.PAYMENT_REPORT_SUCCESS, payload);

export const paymentReportFailure = () =>
  action(ReportsTypes.PAYMENT_REPORT_FAILURE);

// EMTU Report
export const emtuReportRequest = (payload: object) =>
  action(ReportsTypes.EMTU_REPORT_REQUEST, payload);

export const emtuReportSuccess = (payload: {
  emtuReportList: EmtuReportInterface;
}) => action(ReportsTypes.EMTU_REPORT_SUCCESS, payload);

export const emtuReportFailure = () => action(ReportsTypes.EMTU_REPORT_FAILURE);

// TRAVEL BY LINE REPORT
export const travelByLineReportRequest = (payload: object) =>
  action(ReportsTypes.TRAVEL_BY_LINE_REPORT_REQUEST, payload);

export const travelByLineReportSuccess = (payload: {
  travelByLineReportList: TravelByLineInterface;
}) => action(ReportsTypes.TRAVEL_BY_LINE_REPORT_SUCCESS, payload);

export const travelByLineReportFailure = () =>
  action(ReportsTypes.TRAVEL_BY_LINE_REPORT_FAILURE);

// Set Selected Selling Point
export const setSelectedSellingPoint = (payload: {
  selectedSellingPoint: Array<any>;
}) => action(ReportsTypes.SET_SELECTED_SELLING_POINT, payload);

// Set Selected Selling Terminal
export const setSelectedSellingTerminal = (payload: {
  selectedSellingTerminal: Array<any>;
}) => action(ReportsTypes.SET_SELECTED_SELLING_TERMINAL, payload);

// Set Selected Date Type
export const setSelectedDateType = (payload: { selectedDateType: string }) =>
  action(ReportsTypes.SET_SELECTED_DATE_TYPE, payload);

// Set Selected Date Type
export const setSelectedDateTypeBPe = (payload: {
  selectedDateTypeBPe: string;
}) => action(ReportsTypes.SET_SELECTED_DATE_TYPE_BPE, payload);

// Set Selected Date Type
export const setSelectedLineType = (payload: { selectedLineType: string }) =>
  action(ReportsTypes.SET_SELECTED_LINE_TYPE, payload);

// Set Selected Date Type
export const setSelectedStatusDeviceRelease = (payload: {
  selectedStatusDeviceRelease: number | null;
}) => action(ReportsTypes.SET_STATUS_DEVICE_RELEASE, payload);

// Get Shedule List
export const scheduleListRequest = (payload: any) =>
  action(ReportsTypes.SHEDULE_LIST_REQUEST, payload);

export const scheduleListSuccess = (payload: {
  scheduleList: ScheduleInterface[];
}) => action(ReportsTypes.SHEDULE_LIST_SUCCESS, payload);

export const secondScheduleListRequest = (payload: any) =>
  action(ReportsTypes.SECOND_SHEDULE_LIST_REQUEST, payload);

export const secondScheduleListSuccess = (payload: {
  secondScheduleList: ScheduleInterface[];
}) => action(ReportsTypes.SECOND_SHEDULE_LIST_SUCCESS, payload);

export const scheduleListFailure = () =>
  action(ReportsTypes.SHEDULE_LIST_FAILURE);

export const secondScheduleListFailure = () =>
  action(ReportsTypes.SECOND_SHEDULE_LIST_FAILURE);

// Get Shedule
export const scheduleSuccess = (payload: { scheduleData: ScheduleInterface }) =>
  action(ReportsTypes.SHEDULE_SUCCESS, payload);

// Shedule Delete
export const scheduleDeleteRequest = (payload: object) =>
  action(ReportsTypes.SHEDULE_DELETE_REQUEST, payload);

export const scheduleDeleteSuccess = (payload: {
  scheduleDelete: scheduleDeleteInterface;
}) => action(ReportsTypes.SHEDULE_DELETE_SUCCESS, payload);

export const scheduleDeleteFailure = () =>
  action(ReportsTypes.SHEDULE_DELETE_FAILURE);

// Shedule Create
export const scheduleCreateRequest = (payload: any) =>
  action(ReportsTypes.SHEDULE_CREATE_REQUEST, payload);
export const scheduleCreateSuccess = (payload: {
  scheduleData: ScheduleInterface;
}) => action(ReportsTypes.SHEDULE_CREATE_SUCCESS, payload);
export const scheduleCreateFailure = () =>
  action(ReportsTypes.SHEDULE_CREATE_FAILURE);

// Shedule Update
export const scheduleUpdateRequest = (payload: any) =>
  action(ReportsTypes.SHEDULE_UPDATE_REQUEST, payload);
export const scheduleUpdateSuccess = (payload: {
  scheduleData: ScheduleInterface;
}) => action(ReportsTypes.SHEDULE_UPDATE_SUCCESS, payload);
export const scheduleUpdateFailure = () =>
  action(ReportsTypes.SHEDULE_UPDATE_FAILURE);

// Get Request Payment List
export const paymentRequestListRequest = (payload: any) =>
  action(ReportsTypes.PAYMENT_REQUEST_LIST_REQUEST, payload);

export const paymentRequestListSuccess = (payload: {
  paymentRequestList: PaymentRequestInterface[];
}) => action(ReportsTypes.PAYMENT_REQUEST_LIST_SUCCESS, payload);

export const paymentRequestListFailure = () =>
  action(ReportsTypes.PAYMENT_REQUEST_LIST_FAILURE);

// Shipment Line Entries List
export const shipmentByLineRequest = (payload: object) =>
  action(ReportsTypes.SHIPMENT_BY_LINE_REQUEST, payload);

export const shipmentByLineSuccess = (payload: {
  shipmentLineEntries: ShipmentByLineInterface | null;
}) => action(ReportsTypes.SHIPMENT_BY_LINE_SUCCESS, payload);

export const shipmentByLineFailure = () =>
  action(ReportsTypes.SHIPMENT_BY_LINE_FAILURE);

// Set Selected License
export const setSelectedLicense = (payload: { selectedLicense: string }) =>
  action(ReportsTypes.SET_SELECTED_LICENSE, payload);

// Set Selected Prefix
export const setSelectedPrefix = (payload: { selectedPrefix: string }) =>
  action(ReportsTypes.SET_SELECTED_PREFIX, payload);

// Set Selected Car Model
export const setSelectedCarModel = (payload: { selectedCarModel: string }) =>
  action(ReportsTypes.SET_SELECTED_CAR_MODEL, payload);

// Set Selected Car Model
export const setSelectedAge = (payload: { selectedAge: string }) =>
  action(ReportsTypes.SET_SELECTED_AGE, payload);

// Set Selected Sit Capacity
export const setSelectedSitCapacity = (payload: {
  selectedSitCapacity: string;
}) => action(ReportsTypes.SET_SELECTED_SIT_CAPACITY, payload);

// Set Selected Foot Capacity
export const setSelectedFootCapacity = (payload: {
  selectedFootCapacity: string;
}) => action(ReportsTypes.SET_SELECTED_FOOT_CAPACITY, payload);

// Set Selected Accessible
export const setSelectedAccessible = (payload: {
  selectedAccessible: number | null;
}) => action(ReportsTypes.SET_SELECTED_ACCESSIBLE, payload);

// Set Selected Air Conditioned
export const setSelectedAirConditioned = (payload: {
  selectedAirConditioned: number | null;
}) => action(ReportsTypes.SET_SELECTED_AIR_CONDITIONED, payload);

// Set Selected Ticketer
export const setSelectedTicketer = (payload: {
  selectedTicketer: number | null;
}) => action(ReportsTypes.SET_SELECTED_TICKETER, payload);

// Set Selected Register
export const setSelectedRegistry = (payload: { selectedRegistry: string }) =>
  action(ReportsTypes.SET_SELECTED_REGISTRY, payload);

// Set Selected License Number
export const setSelectedLicenseNumber = (payload: {
  selectedLicenseNumber: string;
}) => action(ReportsTypes.SET_SELECTED_LICENSE_NUMBER, payload);

// Set Selected Number
export const setSelectedNumber = (payload: { selectedNumber: string }) =>
  action(ReportsTypes.SET_SELECTED_NUMBER, payload);

// Set Selected Card Number
export const setSelectedCardNumber = (payload: {
  selectedCardNumber: string;
}) => action(ReportsTypes.SET_SELECTED_CARD_NUMBER, payload);

// Set Selected Lot
export const setSelectedLot = (payload: { selectedLot: string }) =>
  action(ReportsTypes.SET_SELECTED_LOT, payload);

// Set Selected Card Type
export const setSelectedCardType = (payload: {
  selectedCardType: number | null;
}) => action(ReportsTypes.SET_SELECTED_CARD_TYPE, payload);

// Set Selected Card Status
export const setSelectedCardStatus = (payload: {
  selectedCardStatus: number | null;
}) => action(ReportsTypes.SET_SELECTED_CARD_STATUS, payload);

// Set Selected Title
export const setSelectedTitle = (payload: { selectedTitle: string }) =>
  action(ReportsTypes.SET_SELECTED_TITLE, payload);

// Set Selected Line Modes
export const setSelectedLineModes = (payload: {
  selectedLineModes: number | null;
}) => action(ReportsTypes.SET_SELECTED_LINE_MODES, payload);

// Set Selected Line Model
export const setSelectedLineModel = (payload: {
  selectedLineModel: number | null;
}) => action(ReportsTypes.SET_SELECTED_LINE_MODEL, payload);

// Set Selected Covered
export const setSelectedCovered = (payload: {
  selectedCovered: number | null;
}) => action(ReportsTypes.SET_SELECTED_COVERED, payload);

// Set Selected BusBay
export const setSelectedBusBay = (payload: { selectedBusBay: number | null }) =>
  action(ReportsTypes.SET_SELECTED_BUS_BAY, payload);

// Set Selected Special Bus Stop
export const setSelectedSpecialBusStop = (payload: {
  selectedSpecialBusStop: number | null;
}) => action(ReportsTypes.SET_SELECTED_SPECIAL_BUS_STOP, payload);

// Set Selected Responsible
export const setSelectedResponsible = (payload: {
  selectedResponsible: string;
}) => action(ReportsTypes.SET_SELECTED_RESPONSIBLE, payload);

// Set Selected Terminal Name
export const setSelectedTerminalName = (payload: {
  selectedTerminalName: string;
}) => action(ReportsTypes.SET_SELECTED_TERMINAL_NAME, payload);

// Set Selected Block Name
export const setSelectedBlockName = (payload: { selectedBlockName: string }) =>
  action(ReportsTypes.SET_SELECTED_BLOCK_NAME, payload);

// Set Selected Total Lines
export const setSelectedTotalLines = (payload: {
  selectedTotalLines: number | null;
}) => action(ReportsTypes.SET_SELECTED_TOTAL_LINES, payload);

// Set Selected Tariff
export const setSelectedTariff = (payload: { selectedTariff: number | null }) =>
  action(ReportsTypes.SET_SELECTED_TARIFF, payload);

// Set Selected Quantity
export const setSelectedQuantity = (payload: {
  selectedQuantity: number | null;
}) => action(ReportsTypes.SET_SELECTED_QUANTITY, payload);

// Set Selected Document
export const setSelectedDocument = (payload: { selectedDocument: string }) =>
  action(ReportsTypes.SET_SELECTED_DOCUMENT, payload);

// Set Selected Document
export const setSelectedEmail = (payload: { selectedEmail: string }) =>
  action(ReportsTypes.SET_SELECTED_EMAIL, payload);

// Set Selected Transport Card
export const setSelectedTransportCard = (payload: {
  selectedTransportCard: string;
}) => action(ReportsTypes.SET_SELECTED_TRANSPORT_CARD, payload);

// Set Selected Selected Device
export const setSelectedDevice = (payload: { selectedDevice: string }) =>
  action(ReportsTypes.SET_SELECTED_DEVICE, payload);

// Set Selected Credit Card
export const setSelectedCreditCard = (payload: {
  selectedCreditCard: string;
}) => action(ReportsTypes.SET_SELECTED_CREDIT_CARD, payload);

// Set Selected Profile Status
export const setSelectedProfileStatus = (payload: {
  selectedProfileStatus: number | null;
}) => action(ReportsTypes.SET_SELECTED_PROFILE_STATUS, payload);

// Set Selected Status
export const setSelectedStatus = (payload: { selectedStatus: number | null }) =>
  action(ReportsTypes.SET_SELECTED_STATUS, payload);

// Set Filtered Items
export const setFilteredItems = (payload: {
  filterItems: Array<FilterItems>;
}) => action(ReportsTypes.SET_FILTERED_ITEMS, payload);

// Set CSV full is checked
export const setCSVFullIsChecked = (payload: { csvFullIsChecked: boolean }) =>
  action(ReportsTypes.SET_CSV_FULL_IS_CHECKED, payload);

// Get IncomingByKmValue List
export const incomingByKmValueReportRequest = (payload: object) =>
  action(ReportsTypes.INCOMING_BY_KM_VALUE_REPORT_REQUEST, payload);

export const incomingByKmValueReportSuccess = (payload: {
  incomingByKmValueList: IncomingByKmValueReportInterface[];
}) => action(ReportsTypes.INCOMING_BY_KM_VALUE_REPORT_SUCCESS, payload);

export const incomingByKmValueReportFailure = () =>
  action(ReportsTypes.INCOMING_BY_KM_VALUE_REPORT_FAILURE);

export const setSelectedIncomingTypes = (payload: {
  selectedIncomingTypes: SelectedReportTypesInterface[];
}) => action(ReportsTypes.SET_SELECTED_INCOMING_TYPES, payload);

// Get Trip Collection Report
export const tripCollectionReportRequest = (payload: object) =>
  action(ReportsTypes.TRIP_COLLECTION_REPORT_REQUEST, payload);

export const tripCollectionReportSuccess = (payload: {
  tripeCollectionReportList: KmPerDayReportInterface[];
}) => action(ReportsTypes.TRIP_COLLECTION_REPORT_SUCCESS, payload);

export const tripCollectionReportFailure = () =>
  action(ReportsTypes.TRIP_COLLECTION_REPORT_FAILURE);

// List Emv Report
export const emvReportRequest = (payload: object) =>
  action(ReportsTypes.EMV_REPORT_REQUEST, payload);

export const emvReportSuccess = (payload: {
  emvReportList: KmPerDayReportInterface[];
}) => action(ReportsTypes.EMV_REPORT_SUCCESS, payload);

export const emvReportFailure = () => action(ReportsTypes.EMV_REPORT_FAILURE);

// List Bpe Report
export const bpeReportRequest = (payload: object) =>
  action(ReportsTypes.BPE_REPORT_REQUEST, payload);

export const bpeReportSuccess = (payload: {
  bpeReportList: InterfaceBpeReportList[];
}) => action(ReportsTypes.BPE_REPORT_SUCCESS, payload);

export const bpeReportFailure = () => action(ReportsTypes.BPE_REPORT_FAILURE);

export const bpeTaxVerificationReportRequest = (payload: object) =>
  action(ReportsTypes.BPE_TAX_VERIFICATION_REPORT_REQUEST, payload);

export const bpeTaxVerificationReportSuccess = (payload: {
  bpeTaxVerificationReportList: InterfaceBpeTaxVerificationReportList[];
}) => action(ReportsTypes.BPE_TAX_VERIFICATION_REPORT_SUCCESS, payload);

export const bpeTaxVerificationReportFailure = () =>
  action(ReportsTypes.BPE_TAX_VERIFICATION_REPORT_FAILURE);

// List Gratuities Report
export const gratuitiesReportRequest = (payload: object) =>
  action(ReportsTypes.GRATUITIES_REPORT_REQUEST, payload);

export const gratuitiesReportSuccess = (payload: {
  gratuitiesReportList: InterfaceGratuitiesReportList[];
}) => action(ReportsTypes.GRATUITIES_REPORT_SUCCESS, payload);

export const gratuitiesReportFailure = () =>
  action(ReportsTypes.GRATUITIES_REPORT_FAILURE);

// List Emv Report DECLINED_BY_REASON
export const emvDeclinedByReasonReportRequest = (payload: object) =>
  action(ReportsTypes.EMV_DECLINED_BY_REASON_REQUEST, payload);

export const emvDeclinedByReasonReportSuccess = (payload: {
  emvDeclinedByReasonReportList: EmvDeclinedByReasonInterface[];
}) => action(ReportsTypes.EMV_DECLINED_BY_REASON_SUCCESS, payload);

export const emvDeclinedByReasonReportFailure = () =>
  action(ReportsTypes.EMV_DECLINED_BY_REASON_FAILURE);

// List Emv Report APPROVED_BY_BRAND
export const emvApprovedByBrandReportRequest = (payload: object) =>
  action(ReportsTypes.EMV_APPROVED_BY_BRAND_REQUEST, payload);

export const emvApprovedByBrandReportSuccess = (payload: {
  emvApprovedByBrandReportList: EmvApprovedByBrandInterface[];
}) => action(ReportsTypes.EMV_APPROVED_BY_BRAND_SUCCESS, payload);

export const emvApprovedByBrandReportFailure = () =>
  action(ReportsTypes.EMV_APPROVED_BY_BRAND_FAILURE);

// List Emv Report APPROVED_BY_DEBT_RECOVERY
export const emvApprovedByDebtRecoveryReportRequest = (payload: object) =>
  action(ReportsTypes.EMV_APPROVED_BY_DEBT_RECOVERY_REQUEST, payload);

export const emvApprovedByDebtRecoveryReportSuccess = (payload: {
  emvApprovedByDebtRecoveryReportList: EmvApprovedByDebtRecoveryInterface[];
}) => action(ReportsTypes.EMV_APPROVED_BY_DEBT_RECOVERY_SUCCESS, payload);

export const emvApprovedByDebtRecoveryReportFailure = () =>
  action(ReportsTypes.EMV_APPROVED_BY_DEBT_RECOVERY_FAILURE);

// List Emv Report APPROVED_BY_DEBT_RECOVERY
export const emvApprovedByAttemptsReportRequest = (payload: object) =>
  action(ReportsTypes.EMV_APPROVED_BY_ATTEMPTS_REQUEST, payload);

export const emvApprovedByAttemptsReportSuccess = (payload: {
  emvApprovedByAttemptsReportList: EmvApprovedByAttemptsInterface[];
}) => action(ReportsTypes.EMV_APPROVED_BY_ATTEMPTS_SUCCESS, payload);

export const emvApprovedByAttemptsReportFailure = () =>
  action(ReportsTypes.EMV_APPROVED_BY_ATTEMPTS_FAILURE);

// List Emv Report APPROVED_BY_DEBT_RECOVERY
export const emvApprovedByFirstTapByBrandReportRequest = (payload: object) =>
  action(ReportsTypes.EMV_APPROVED_FIRST_TAP_BY_BRAND_REQUEST, payload);

export const emvApprovedByFirstTapByBrandReportSuccess = (payload: {
  emvApprovedByFirstTapByBrandReportList: EmvApprovedByFirstTapByBrandInterface[];
}) => action(ReportsTypes.EMV_APPROVED_FIRST_TAP_BY_BRAND_SUCCESS, payload);

export const emvApprovedByFirstTapByBrandReportFailure = () =>
  action(ReportsTypes.EMV_APPROVED_FIRST_TAP_BY_BRAND_FAILURE);

// List Emv Report EMV_ENTRY_GET
export const emvEntryGetRequest = (payload: {
  body: object;
  isBalance?: boolean;
}) => action(ReportsTypes.EMV_ENTRY_GET_REQUEST, payload);

export const emvEntryGetSuccess = (payload: {
  emvEntryGetList: EmvEntryGetInterface[];
}) => action(ReportsTypes.EMV_ENTRY_GET_SUCCESS, payload);

export const emvEntryGetFailure = () =>
  action(ReportsTypes.EMV_ENTRY_GET_FAILURE);

// List Emv Report EMV_ENTRY_GET_HISTORY
export const emvEntryGetHistoryRequest = (payload: object) =>
  action(ReportsTypes.EMV_ENTRY_GET_HISTORY_REQUEST, payload);

export const emvEntryGetHistorySuccess = (payload: {
  emvEntryGetHistoryList: EmvEntryGetHistoryInterface[];
}) => action(ReportsTypes.EMV_ENTRY_GET_HISTORY_SUCCESS, payload);

export const emvEntryGetHistoryFailure = () =>
  action(ReportsTypes.EMV_ENTRY_GET_HISTORY_FAILURE);

// List Emv Report ORDERS_BY_SCHOOL_REPORT
export const ordersBySchoolReportRequest = (payload: object) =>
  action(ReportsTypes.ORDERS_BY_SCHOOL_REPORT_REQUEST, payload);

export const ordersBySchoolReportSuccess = (payload: {
  ordersBySchoolsList: any;
}) => action(ReportsTypes.ORDERS_BY_SCHOOL_REPORT_SUCCESS, payload);

export const ordersBySchoolReportFailure = () =>
  action(ReportsTypes.ORDERS_BY_SCHOOL_REPORT_FAILURE);

// List Emv Report ORDERS_BY_SCHOOL_REPORT
export const studentCardsReportRequest = (payload: object) =>
  action(ReportsTypes.STUDENT_CARDS_REPORT_REQUEST, payload);

export const studentCardsReportSuccess = (payload: { studentCardsList: any }) =>
  action(ReportsTypes.STUDENT_CARDS_REPORT_SUCCESS, payload);

export const studentCardsReportFailure = () =>
  action(ReportsTypes.STUDENT_CARDS_REPORT_FAILURE);

// Get Trip Collection Report
export const tripControlDetailsResumeReportRequest = (payload: object) =>
  action(ReportsTypes.TRIP_CONTROL_DETAIL_RESUME_REPORT_REQUEST, payload);

export const tripControlDetailsResumeReportSuccess = (payload: {
  tripControlDetailsResumeReportList: KmPerDayReportInterface[];
}) => action(ReportsTypes.TRIP_CONTROL_DETAIL_RESUME_REPORT_SUCCESS, payload);

export const tripControlDetailsResumeReportFailure = () =>
  action(ReportsTypes.TRIP_CONTROL_DETAIL_RESUME_REPORT_FAILURE);

// Set Selected Status
export const setSelectedEmvStatus = (payload: {
  selectedEmvStatus: number | string;
}) => action(ReportsTypes.SET_SELECTED_EMV_STATUS, payload);

// List Creditis by School Report
export const creditisBySchoolReportRequest = (payload: object) =>
  action(ReportsTypes.CREDITIS_BY_SCHOOL_REPORT_REQUEST, payload);

export const creditisBySchoolReportSuccess = (payload: {
  creditisBySchoolReportList: KmPerDayReportInterface[];
}) => action(ReportsTypes.CREDITIS_BY_SCHOOL_REPORT_SUCCESS, payload);

export const creditisBySchoolReportFailure = () =>
  action(ReportsTypes.CREDITIS_BY_SCHOOL_REPORT_FAILURE);

// List Usage Statistics Report
export const usageStatisticsReportRequest = (payload: object) =>
  action(ReportsTypes.USAGE_STATISTICS_REPORT_REQUEST, payload);

export const usageStatisticsReportSuccess = (payload: {
  usageStatisticsReportList: UsageStatisticsInterface[];
}) => action(ReportsTypes.USAGE_STATISTICS_REPORT_SUCCESS, payload);

export const usageStatisticsReportFailure = () =>
  action(ReportsTypes.USAGE_STATISTICS_REPORT_FAILURE);
// List Profil by age group Report
export const profileByAgGroupReportRequest = (payload: object) =>
  action(ReportsTypes.PROFILE_BY_AGE_ROUPE_REPORT_REQUEST, payload);

export const profileByAgGroupReportSuccess = (payload: {
  profileByAgeGroupList: ProfileByAgeGroupListInterface[];
}) => action(ReportsTypes.PROFILE_BY_AGE_ROUPE_REPORT_SUCCESS, payload);

export const profileByAgGroupReportFailure = () =>
  action(ReportsTypes.PROFILE_BY_AGE_ROUPE_REPORT_FAILURE);

// get Trips Request
export const getTripsRequest = (payload: object) =>
  action(ReportsTypes.GET_TRIP_REQUEST, payload);

// Set Selected schoolCode
export const setSelectedSchoolCode = (payload: {
  selectedSchoolCode: string | null;
}) => action(ReportsTypes.SET_SELECTED_SHOOL_CODE, payload);
// External Reports
export const setExternalReports = (payload: {
  externalReports: ExternalReportsInterface[];
}) => action(ReportsTypes.EXTERNAL_REPORTS, payload);

// Set Selected schoolType
export const setSelectedSchoolType = (payload: {
  selectedSchoolType: SelectedTokenStatus[];
}) => action(ReportsTypes.SET_SELECTED_SHOOL_TYPE, payload);

// Set whether the search field is active
export const setIsSearchActive = (payload: boolean) =>
  action(ReportsTypes.SET_IS_SEARCH_ACTIVE, payload);

export const setSelectedCompanies = (payload: {
  selectedCompanies: SelectedCompaniesInterface[];
}) => action(ReportsTypes.SET_SELECTED_COMPANIES, payload);

// List Emv Report
export const employeeTripSapResumeReportRequest = (payload: object) =>
  action(ReportsTypes.EMPLOYEE_TRIP_SAP_RESUME_REPORT_REQUEST, payload);

export const employeeTripSapResumeReportSuccess = (payload: {
  employeeTripSapResumeReport: KmPerDayReportInterface[];
}) => action(ReportsTypes.EMPLOYEE_TRIP_SAP_RESUME_REPORT_SUCCESS, payload);

export const employeeTripSapResumeReportFailure = () =>
  action(ReportsTypes.EMPLOYEE_TRIP_SAP_RESUME_REPORT_FAILURE);

// Set Selected paymentDay
export const setSelectedPaymentDay = (payload: {
  selectedPaymentDay: Date | null;
}) => action(ReportsTypes.SET_SELECTED_PAYMENT_DAY, payload);

// Durable Reports - Client
export const reportDurableClientRequest = (payload: Object) =>
  asyncAction(ReportsTypes.REPORT_DURABLE_CLIENT_REQUEST, payload);

export const reportDurableClientSuccess = (
  payload: ReportDurableClientResponseInterface,
) => action(ReportsTypes.REPORT_DURABLE_CLIENT_SUCCESS, payload);

export const reportDurableClientFailure = () =>
  action(ReportsTypes.REPORT_DURABLE_CLIENT_FAILURE);

// Durable Reports - Status
export const reportDurableStatusRequest = (
  payload: ReportDurableStatusPayloadInterface,
) => action(ReportsTypes.REPORT_DURABLE_STATUS_REQUEST, payload);

export const reportDurableStatusSuccess = (payload: {
  durableStatus: ReportDurableStatusResponseInterface;
}) => action(ReportsTypes.REPORT_DURABLE_STATUS_SUCCESS, payload);

export const reportDurableStatusFailure = () =>
  action(ReportsTypes.REPORT_DURABLE_STATUS_FAILURE);

// Durable Reports - List
export const reportDurableListRequest = (payload: Object) =>
  action(ReportsTypes.REPORT_DURABLE_LIST_REQUEST, payload);

export const reportDurableListSuccess = (payload: {
  durableList: ReportDurableListResponseInterface[];
}) => action(ReportsTypes.REPORT_DURABLE_LIST_SUCCESS, payload);

export const reportDurableListFailure = () =>
  action(ReportsTypes.REPORT_DURABLE_LIST_FAILURE);

// Durable Reports - Cancel
export const reportDurableCancelRequest = (
  payload: ReportDurableCancelPayloadInterface,
) => action(ReportsTypes.REPORT_DURABLE_CANCEL_REQUEST, payload);

export const reportDurableCancelSuccess = (payload: {
  durableCancel: ReportDurableCancelResponseInterface;
}) => action(ReportsTypes.REPORT_DURABLE_CANCEL_SUCCESS, payload);

export const reportDurableCancelFailure = () =>
  action(ReportsTypes.REPORT_DURABLE_CANCEL_FAILURE);

// Durable Reports - Download
export const reportDurableDownloadRequest = (
  payload: ReportDurableDownloadPayloadInterface,
) => asyncAction(ReportsTypes.REPORT_DURABLE_DOWNLOAD_REQUEST, payload);

export const reportDurableDownloadSuccess = () =>
  action(ReportsTypes.REPORT_DURABLE_DOWNLOAD_SUCCESS);

export const reportDurableDownloadFailure = () =>
  action(ReportsTypes.REPORT_DURABLE_DOWNLOAD_FAILURE);
